import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import store from '../../store';

@customElement('shared-llmf-table')
export class SharedLlmfTable extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: block;
			container-type: inline-size;
		}

		table {
			border-collapse: collapse;
			width: 100%;
			border-bottom: 1px solid rgb(198, 198, 198);
			border-top: 1px solid rgb(198, 198, 198);
			margin-top: 1cqw;
			margin-bottom: 1cqw;
		}

		tr {
			border-bottom: 1px solid rgb(198, 198, 198);
		}

		tr:last-child {
			border-bottom: none;
		}

		th {
			font: var(--font-specsheet-print-small-bold);
			font-size: 2cqw;
			text-align: left;
		}

		td {
			font: var(--font-specsheet-print-small-text);
			font-size: 2cqw;
			padding: 1cqw 1cqw;
		}

		.info {
			font: var(--font-specsheet-print-small-text);
			font-size: 2cqw;
		}
    `
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.llmf = state.productData.llmf;
	}


	render() {
		return html`
			${when(this.llmf !== null, () => html`
				<table>
					<tr>
						<th>
							<trans-label key="LE_OperatingTimeLED" context="D"></trans-label>
						</th>
						${repeat(this.llmf.llmftable, (item) => (
							html`
								<td>${item.ophours}</td>`
						))}
					</tr>
					<tr>
						<th>
							<trans-label key="LE_Lumenmaintenance" context="D"></trans-label>
						</th>
						${repeat(this.llmf.llmftable, (item) => (
							html`
								<td>${item.factor * 100}%</td>`
						))}
					</tr>
					<tr>
						<th>
							<trans-label key="LE_LLMF" context="D"></trans-label>
							*
						</th>
						${repeat(this.llmf.llmftable, (item) => (
							html`
								<td>${item.factor}</td>`
						))}
					</tr>
				</table>
				<p class="info">* = ${msg('Lamp lumen maintenance factor')}</p>
			`)}
        `;
	}
}
